import React, { Component } from "react";
import { connect, useDispatch } from "react-redux";
import { Form, Button } from "react-bootstrap";
import NoteComponent from "../Notes/NoteComponent";
import withFetchHook from "../withFetchHook";
import ReactPaginate from "react-paginate";
import { FormInput } from "./PaymentsTab/onestep-library/BaseUI";
import { intersection } from "lodash";
import classnames from 'classnames'
import { isEqual } from "lodash";
import NoteShareWith from "../Notes/NoteShareWith";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

class NotesTab extends Component {
  state = {
    currentPage: 1,
    body: "",
    contacted_at: null,
    follow_up_at: null,
    risk_level: null,
    note_tags: [],
    userTags: [],
    groupTags: [],
  }

  handleChange(e) {
    this.setState({ body: e.target.value });
  }

  saveNoteFunction = (e) => {
    this.props.dispatch(this.handleCreate())
  }

  componentDidMount() {
    document.addEventListener('saveNote', this.saveNoteFunction)
    if (this.props.isActive) {
      this.fetchNotes()
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { isActive } = this.props;
    if (isActive && (!isEqual(prevState, this.state) || prevProps.isActive !== isActive)) {
      this.fetchNotes()
    }
  }

  componentWillUnmount() {
    document.removeEventListener('saveNote', this.saveNoteFunction)
  }

  fetchNotes() {
    const { organizationName, resident, isActive } = this.props;
    const { currentPage } = this.state;
    
    if (!isActive) return;

    this.props.fetch(`/organizations/${organizationName}/residents/${resident.id}/notes.json`, {
      data: {
        page: currentPage
      }
    }).then((notes) => {
      this.props.updateNotes(notes);
      this.setState({ userTags: notes.user_tags, groupTags: notes.group_tags });
    })
  }

  renderPagination() {
    const { total_pages } = this.props.notes;
    const { currentPage } = this.state;

    return (
      <ReactPaginate
        containerClassName="pagination"
        pageClassName="page-item"
        pageLinkClassName="page-link"
        activeClassName="active"
        pageCount={total_pages}
        forcePage={currentPage - 1}
        onPageChange={(page) =>
          this.setState({ currentPage: page.selected + 1 })
        }
      />
    );
  }

  handleCreate() {
    const { organizationName, resident } = this.props;
    const { contacted_at, follow_up_at, risk_level, body, note_tags } = this.state;
    this.props.fetch(`/organizations/${organizationName}/residents/${resident.id}/notes.json`, {
      method: "POST",
      contentType: "application/json",
      data: JSON.stringify({
        note: {
          body: body,
          contacted_at: !!contacted_at ? contacted_at.format('YYYY-MM-DD') : null,
          follow_up_at: !!follow_up_at ? follow_up_at.format('YYYY-MM-DD') : null,
          risk_level: !!risk_level ? this.state.risk_level.value : null,
          note_tags_attributes: note_tags.map((tag) => {
            return {
              recipient_id: tag.value,
              recipient_type: tag.recipient_type
            }
          })
        }
      })
    }).then((data) => {
      this.props.createNote(data);
      this.props.dispatch(() => ({
        type: "UPDATE_RESIDENT_UPDATED_AT",
        payload: { resident_updated_at: data.updated_at }
      }));
      this.setState({ body: "", contacted_at: null, follow_up_at: null, risk_level: null, note_tags: []});
    })
  }

  render() {
    const { resident, permissions, no_occupancies, isStaffApp } = this.props
    return (
      <div>
        {
          intersection(permissions, ["create"]).length > 0 &&
          <Form className={classnames({ "mb-4 pt-2 border-bottom pb-4": !isStaffApp })}>
            <Form.Group className={classnames({ "col-12": !isStaffApp })} controlId="noteBody">
              <Form.Label>Note</Form.Label>
              <Form.Control
                as="textarea"
                placeholder="Enter notes here..."
                style={{ minHeight: isStaffApp ? '8rem' : '5rem' }}
                value={this.state.body}
                onChange={this.handleChange.bind(this)} />
            </Form.Group>
            <div className={classnames({ "col-12": !isStaffApp, 'mb-2': !isStaffApp })}>
              <label> Share With
                <OverlayTrigger
                  key='top'
                  placement='top'
                  overlay={
                    <Tooltip id={`tooltip-top`}>
                      If you do not see the staff member you are looking for in the list, it is likely that this staff
                      member does not have permission to view this client or notes. Please check in with your admin to
                      change this.
                    </Tooltip>
                  }
                >
                  <i className="fa fa-info-circle text-primary ml-1"
                     aria-hidden="true"
                     data-toggle="tooltip"
                     data-placement="top"
                     title=""
                  ></i>
                </OverlayTrigger>
              </label>
              <NoteShareWith
                groupTags={this.state.groupTags}
                userTags={this.state.userTags}
                values={this.state.note_tags}
                onChange={(updatedNoteTags) => this.setState({ note_tags: updatedNoteTags })}
              />
            </div>
            {
              !resident["is_moved_in?"] &&
              <div className="d-flex">
                <div className="col-6">
                  <FormInput
                    type="date"
                    label="Follow Up On"
                    value={this.state.follow_up_at}
                    handleChange={(follow_up_at) => this.setState({ follow_up_at })}
                    placeholder="Enter Follow Up On Date..." />
                </div>
                {!no_occupancies &&
                  <div className="col-6">
                    <FormInput
                      type="date"
                      label="Contact Date"
                      value={this.state.contacted_at}
                      handleChange={(contacted_at) => this.setState({ contacted_at })}
                      placeholder="Enter Contact Date..." />
                  </div>
                }
                {!no_occupancies &&
                  <div className="col-6">
                    <FormInput
                      label="Risk Level"
                      type="select"
                      placeholder="Select Risk Level.."
                      value={this.state.risk_level}
                      options={[{ label: 'Low', value: 'low' }, { label: 'Medium', value: 'medium' }, { label: 'High', value: 'high' }]}
                      handleChange={(risk_level) => this.setState({ risk_level })} />
                  </div>
                }
              </div>
            }
            {
              !isStaffApp &&
              <div className="col-12 d-flex justify-content-end">
                <Button
                  className={classnames({ "mb-4": isStaffApp })}
                  size="sm"
                  onClick={() => {
                    this.handleCreate();
                  }}>
                  Save
                </Button>
              </div>
            }
          </Form>
        }
        <div>
          {
            !isStaffApp &&
            intersection(permissions, ["export_csv"]).length > 0 &&
            <div className="d-flex justify-content-end mb-2">
              <Button
                variant="link"
                size="sm"
                href={window.location.href + `/notes.csv`}>
                Export as CSV
              </Button>
            </div>
          }
          {
            this.props.notes.notes.length > 0 ?
              <>

                <div className="d-flex justify-content-center mt-4">
                  {this.renderPagination()}
                </div>
                {
                  this.props.notes.notes.sort((a, b) => b.starred - a.starred).map((note) => {
                    return (
                      <NoteComponent note={note} key={note.id} userTags={this.state.userTags} groupTags={this.state.groupTags} />
                    )
                  })
                }
              </> :
              <div className="text-center p-3">No Notes</div>
          }
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    isStaffApp: state.config.isStaffApp,
    notes: state.notes,
    action: state.ui.action,
    organizationName: state.organization.name,
    resident: state.resident,
    no_occupancies: !state.occupancies.length,
    permissions: state.permissions,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    createNote: (note) => dispatch({ type: "CREATE_NOTE", payload: { note } }),
    dispatch: (func) => dispatch(func()),
    updateNotes: (notes) =>
      dispatch({ type: "UPDATE_NOTES", payload: { notes } }),
    updatePage: (currentPage) =>
      dispatch({ type: "UPDATE_CURRENT_PAGE", payload: { currentPage } }),
  };
};

export default withFetchHook(connect(mapStateToProps, mapDispatchToProps)(NotesTab));
